import { toPairs } from "ramda";

import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { ILocationSuggestion } from "utils/geo";

type TInput = { term: string };
export type TOutput = Array<ILocationSuggestion>;

export default class AutocompleteApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;

  resolveUri({ term }: TInput): string {
    return `/fe-api/autocomplete?term=${term}`;
  }

  mapResponseData(_: number, data: any): TOutput | null {
    return toPairs(data).map((x) => ({
      id: x[0] as string,
      label: x[1] as string,
    }));
  }
}
